<template>
  <section>
    <search :searchStatus="false"></search>
    <section class="padding-footer">
      <div class="util-detail-header">
        <div class="util-header-top">
          <div>
            <img src="@/assets/img/util-tab-5-title.svg" />
          </div>
          <div class="util-detail-header-title">
            <strong>Tambah Pencatatan Downtime</strong>
          </div>
        </div>
        <span>Masukkan Catatan Sesuai Form</span>
      </div>
      <div class="illusion"></div>
      <b-container>
        <section style="padding-inline: 12px; padding-top: 8px">
          <ValidationObserver ref="observer">
            <b-form
              slot-scope="{ validate }"
              @submit.prevent="validate().then(submitTicket)"
            >
              
            <div style="display: flex; flex-direction: column; gap: 8px">
                <ValidationProvider rules="required" name="Start At">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-input
                      class="txt-input2"
                      v-bind:class="{ active: isActive }"
                      placeholder="Start At"
                      v-model="date"
                      :state="errors[0] ? false : valid ? true : null"
                      @focus="toDateTime"
                      @blur="toText"
                      type="text"
                    ></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required" name="Shift">
                <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                  <div
                    class="box-select"
                    v-bind:class="{ active: isActive }"
                  >
                    <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                    <b-form-select
                      v-model="shift"
                      :options="opt_shift"
                      class="select-option"
                      value-field="value"
                      text-field="text"
                      disabled-field="notEnabled"
                      :state="errors[0] ? false : valid ? true : null"
                    ></b-form-select>
                  </div>
                  <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
              <ValidationProvider rules="required" name="Mesin">
                <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                  <div
                    class="box-select"
                    v-bind:class="{ active: isActive }"
                  >
                    <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                    <select-autocomplete
                      v-model="machine"
                      :list="opt_machine"
                      :placeholder="'Select Machine'"
                      :state="errors[0] ? false : valid ? true : null"
                      @change="getSparepart"
                    ></select-autocomplete>
                  </div>
                  <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
              <ValidationProvider rules="required" name="Deskripsi">
                <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                  <b-form-textarea
                    id="textarea"
                    v-model="description"
                    placeholder="Problem"
                    rows="2"
                    class="text-area1"
                    v-bind:class="{ active: isActive }"
                    :state="errors[0] ? false : valid ? true : null"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="inputLiveFeedback">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
              <ValidationProvider rules="required" name="Dateline">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-input
                      class="txt-input2"
                      v-bind:class="{ active: isActive }"
                      placeholder="Dateline Preventive"
                      v-model="dateline"
                      :state="errors[0] ? false : valid ? true : null"
                      type="text"
                      @focus="toDateTime"
                      @blur="toText"
                    ></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>

              </div>
            </b-form>
          </ValidationObserver>
        </section>
      </b-container>
    </section>
    <util-action @submit="submit"></util-action>
    <!-- <MenuFooter /> -->
  </section>
</template>
<script lang="js">
import dayjs from "dayjs";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Search from "@/components/Search.vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilAction from "@/views/pages/Utilities/Components/Util-Action.vue";
import { api } from "@/api/api";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";

@Component({
    components: {
        MenuFooter,
        Search,
        ValidationObserver,
        ValidationProvider,
        UtilAction,
        SelectAutocomplete,

    },
})
export default class Utilities extends Vue {

    subject = ""
    isActive = false
    errors = []
    toDate(e) {
      e.target.type = 'date'
    }
    toDateTime(e) {
      e.target.type = 'datetime-local'
    }
  toText(e) {
    if(!e.target.value){
      e.target.type = 'text'
    }
  }
    
    opt_shift = []
    opt_machine = []

    date = null
    division = null
    shift = null
    machine = null
    description = null
    dateline = null
    

    mounted() {
      this.getShift()
      this.getMachine()
    }


    getShift() {
      api('shift_option').then(res => {
        if (res.code == 200) {
          this.opt_shift = [{value:null,text:"Select Shift"}, ...res.data.map(item => {
            return {
              value: item.id,
              text: item.label
            }
          })]
        }
      })
    }

    getMachine() {
      api('machine_option').then(res => {
        if (res.code == 200) {
          this.opt_machine = [{value:null,text:"Select Machine"}, ...res.data.map(item => {
            return {
              value: item.id,
              text: item.name
            }
          })]
        }
      })
    }



    submit(){
      if (this.date && this.shift && this.machine && this.description && this.dateline) {
        let data = {
          "down_at" : dayjs(this.date).format("YYYY-MM-DD HH:mm:ss"),
          "shift" : this.shift,
          "machines_id" : this.machine,
          "problems" : this.description,
          "dateline" : dayjs(this.dateline).format("YYYY-MM-DD HH:mm:ss")
        }
        api('downtime_add',{body:data}).then(res => {
          if (res.code == 200) {
            this.$router.push('/downtime')
          } else {
          this.$swal("Peringatan", res.data.message, "warning");
        }
      })
      .catch((err) => {
        this.$swal("Error", err?.response?.data?.message, "error");
      });
      }else{
      this.$swal("Error", "Semua field wajib diisi", "error");
    }
    }
}
</script>

<style>
.box-select input{
  margin-top: -8px !important;
  padding-inline: 0 !important;
}
</style>